<template>
  <div class="game-results-container">
    <div>
      To continue, load the following game file using the green File Load button
      above:
    </div>
    <div class="fileName">
      {{ fileName }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ResumeGameNotice",
  computed: {
    ...mapState(["fileName"]),
  },
};
</script>

<style scoped>
.game-results-container {
  font-size: min(20px, 3vmin);
  height: 200px;
  line-height: min(50px, 4.5vmin);
  border-bottom: 1px solid black;
  margin: 30px 50px;
}

.fileName {
  font-family: Consolas, Menlo, "Courier New", Courier, monospace;
}
</style>